export const addBlur = () => document.querySelector<HTMLDivElement>('#wrap')?.classList.add('blur')

export const removeBlur = () => document.querySelector<HTMLDivElement>('#wrap')?.classList.remove('blur')
